import { useFeatureFlags } from '@funtech-int/yango-shared';

import { featureFlagsScheme } from '../../../../lib/featureFlags';

export function useYaspVersion(): string | undefined {
    const yaspVersion = useFeatureFlags(featureFlagsScheme).flags.get('yaspVersion');

    if (typeof yaspVersion === 'string' && yaspVersion.length > 0) {
        return yaspVersion;
    }
}
